module.exports = __webpack_public_path__ + "./assets/email_graphic.svg";